<template>
  <main class="ref-auth register-target">
    <img class="register-target__background" src="https://www.midnightdesires.vip/img/login/login-bg.png" alt="">
    <div class="register-target__shade" aria-hidden="true"></div>
    <PageHeader back :service="false">
      <template #right><router-link to="/Language" class="ref-icon-button" :aria-label="$t('setting.language')"><img class="register-target__language" src="https://www.midnightdesires.vip/img/login/nav10.png" alt=""></router-link></template>
    </PageHeader>
    <SiteLogo class="register-target__logo" placement="auth" :alt="$t('frontend.common.brand_logo')" />
    <form class="ref-auth__form" @submit.prevent="doRegister">
      <label class="ref-auth__field"><input v-model.trim="username" autocomplete="username" :placeholder="$t('auth.username_place')"></label>
      <label class="ref-auth__field"><input v-model="password" :type="passwordType" autocomplete="new-password" :placeholder="$t('auth.pwd_place')"><button type="button" @click="switchPasswordType"><van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'" /></button></label>
      <label class="ref-auth__field"><input v-model.trim="code" autocomplete="off" :placeholder="$t('auth.invite_code_place')"></label>
      <label class="register-target__agreement"><van-checkbox v-model="checked" /><span>{{ $t('auth.agreement_place') }}</span></label>
      <button class="ref-primary" type="submit" :disabled="submitting">{{ submitting ? $t('auth.registering') : $t('auth.register') }}</button>
    </form>
  </main>
</template>

<script>
import { getLanguage } from '../../common/language';
import PageHeader from '../../common/PageHeader';
import SiteLogo from '../../common/SiteLogo';
export default {
  components: { PageHeader, SiteLogo },
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      submitting: false,
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    async doRegister() {
      if (this.submitting) return;
      this.username = this.username.trim();
      this.code = this.code.trim();
      if(!this.username){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (Array.from(this.username).length > 255) {
        this.$toast.fail(this.$t('auth.username_invalid'));
        return false;
      }
      if(!this.password){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      const passwordLength = Array.from(this.password).length;
      if (passwordLength < 6 || passwordLength > 12) {
        this.$toast.fail(this.$t('auth.password_length'));
        return false;
      }
      if(!this.code){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.submitting = true;
      try {
        const res = await this.$http({
          method: 'post',
          data: {
            username: this.username,
            password: this.password,
            code: this.code,
            lang: getLanguage()
          },
          url: 'member_register'
        });
        if (Number(res.code) === 200) {
          if (!['number', 'string'].includes(typeof res.data) || !/^[1-9]\d*$/.test(String(res.data))) {
            this.$toast.fail(this.$t('common.response_error'));
            return;
          }
          localStorage.setItem('token', res.data);
          this.$toast.success(this.$t('auth.register_success'));
          this.$router.push('/Mine');
        } else {
          this.$toast.fail(res.msg || this.$t('auth.register_failed'));
        }
      } catch (error) {
        this.$toast.fail(this.$t('common.network_error'));
      } finally {
        this.submitting = false;
      }
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style>
.register-target {
  position: relative;
  min-height: 100vh;
  height: 100vh;
  padding: 0;
  overflow-y: scroll;
  background: linear-gradient(-45deg, #5e347f, #c2a8dc) !important;
}

.register-target__background { position: absolute; inset: 0; z-index: 0; width: 100%; height: 100%; object-fit: cover; }
.register-target__shade { position: absolute; inset: 0; z-index: 0; background: linear-gradient(180deg, rgba(255, 255, 255, 0), #5e347f); }
.register-target > :not(.register-target__background):not(.register-target__shade) { position: relative; z-index: 1; }

.register-target .ref-header { height: 13.25vw; padding: 0 2.75vw; background: transparent; }
.register-target .ref-header__side { min-width: 2.75rem; }
.register-target .ref-header__side .ref-icon-button { width: 2.75rem; }
.register-target .ref-icon-button { min-height: 13.25vw; }

.register-target__language { width: 2.6875rem; height: 2.6875rem; object-fit: contain; }
.register-target__logo { display: block; width: 43.25vw; height: 27vw; margin: 0 auto; object-fit: cover; }
.register-target .ref-auth__form { max-width: none; padding: 14.25vw 8vw 0; }
.register-target .ref-auth__field { width: 75vw; height: 9.25vw; margin: 0 2.75vw 7.25vw; }
.register-target .ref-auth__field:last-of-type { margin-bottom: 4.25vw; }
.register-target .ref-auth__field input { min-height: 9.25vw; padding: 0 2.8rem; font-size: 0.75rem; }
.register-target .ref-auth__field > .van-icon { left: 1.1rem; font-size: 1rem; }
.register-target .ref-auth__field button { right: 0.45rem; }
.register-target__agreement { display: flex; align-items: flex-start; width: 80.25vw; min-height: 8vw; gap: 0.35rem; margin-top: -0.2rem; color: #fff; font-size: 0.625rem; line-height: 1.25; transform: translateY(-1px); }
.register-target__agreement span { flex: 1; }
::v-deep .register-target__agreement .van-checkbox__icon { font-size: 0.9rem; }
::v-deep .register-target__agreement .van-checkbox__icon--checked .van-icon { color: #8350bb; border-color: #fff; background: #fff; }
.register-target .ref-primary { width: 80.25vw; min-height: 13.25vw; margin-top: 3.25vw; border-radius: 999px; background: linear-gradient(100deg, #8241b9, #7436af); font-size: 0.875rem; }
</style>
